<template>
    <form id="KidsDesireForm" @submit.prevent="form.post(props.action)">
        <RadioGroupField
            v-model="form.wants_kids"
            :error="translateMaybe(form.errors.wants_kids)"
            :options="options"
            required
            name="wants_kids"
            class="my-2"
            lg
            setup
            :option-classes="grid.md ? 'text-h4 my-2' : 'my-3'"
        />
    </form>
</template>

<script setup>
import RadioGroupField from "@/Components/FormFields/RadioGroupField.vue";
import { OPTIONS } from "@/Helpers/constants.js";
import { translateMaybe } from "@/Helpers/translateMaybe.js";
import { useForm } from "@inertiajs/vue3";
import { computed, watchEffect } from "vue";
import { useGrid } from "vue-screen";

const props = defineProps({
    action: {
        type: String,
        default: null,
    },
    wantsKids: {
        type: Boolean,
        default: false,
    },
    form: {
        type: Object,
        default: null,
    },
});

const emit = defineEmits(["form-complete"]);
const grid = useGrid("tailwind");

const form =
    props.form ??
    useForm({
        wants_kids: props.wantsKids,
    });

const options = computed(() => OPTIONS.DESIRE_FOR_CHILDREN.slice(0, -1));

watchEffect(() => {
    emit("form-complete", Boolean(form.wants_kids));
});
</script>
